export default __webpack_public_path__ + "static/media/icone-id-positiva.bcf019e5.svg";